/**
 * Empty State Component
 * Display when no data is available
 */

import React from 'react';
import { Folder, Plus } from '@phosphor-icons/react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

export const EmptyState = ({
  icon: Icon = Folder,
  title = 'No data found',
  description = 'Get started by adding your first item.',
  actionLabel,
  onAction,
  className,
}) => {
  return (
    <div 
      className={cn(
        'flex flex-col items-center justify-center py-16 px-4 text-center',
        className
      )}
    >
      <div className="w-16 h-16 rounded-full bg-secondary flex items-center justify-center mb-4">
        <Icon size={32} className="text-muted-foreground" />
      </div>
      
      <h3 className="text-lg font-semibold text-foreground mb-1">
        {title}
      </h3>
      
      <p className="text-sm text-muted-foreground max-w-sm mb-6">
        {description}
      </p>

      {actionLabel && onAction && (
        <Button onClick={onAction} className="bg-[#3A4A40] hover:bg-[#2E3B33]">
          <Plus size={18} className="mr-1" />
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
